/**
 * Sanitisation d'HTML côté client via DOMPurify — à utiliser avant tout
 * `dangerouslySetInnerHTML` pour éliminer les vecteurs XSS.
 *
 * Usage :
 *   import { sanitize } from "../../lib/sanitize";
 *   <div dangerouslySetInnerHTML={{ __html: sanitize(untrustedHtml) }} />
 */
import DOMPurify from "dompurify";

// Config permissive pour les emails/CMS (autorise mise en forme riche)
// mais bloque strictement les scripts, les URI dangereuses et les event handlers.
const CMS_CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "hr", "b", "strong", "i", "em", "u", "s", "small", "sub", "sup",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "a", "img", "figure", "figcaption",
    "blockquote", "code", "pre",
    "table", "thead", "tbody", "tr", "th", "td",
    "div", "span",
  ],
  ALLOWED_ATTR: [
    "href", "target", "rel", "src", "alt", "title", "width", "height",
    "class", "style",
    "colspan", "rowspan",
  ],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|\/[^\/]|\.\.?\/|#|data:image\/(?:png|jpe?g|gif|webp|svg\+xml);base64,)/i,
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus"],
};

/**
 * Nettoie l'HTML pour affichage sûr. Renvoie une chaîne "safe" pour
 * `dangerouslySetInnerHTML`.
 */
export function sanitize(html) {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, CMS_CONFIG);
}

/**
 * Variante plus stricte pour du texte simple avec un peu de mise en forme
 * (utile pour les prévisualisations d'emails).
 */
export function sanitizeStrict(html) {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ["p", "br", "b", "strong", "i", "em", "u", "a", "ul", "ol", "li"],
    ALLOWED_ATTR: ["href", "target", "rel"],
    ALLOWED_URI_REGEXP: /^(?:https?|mailto|tel):/i,
  });
}
